<div class="dialogue-content">
    <div class="mat-dialogue-header">
        <h4 class="mat-dialog-title previewHeading" id="modal-basic-title">{{LabelConstant.refundDetails}}</h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
    </div>
</div>

<mat-dialog-content class="px-3">
    <div *ngIf="reportDetail.status == reportStatus.REJECTED">
        <div class="refund_box reject p-3 mb-3">
            <div class="imagebox">
                <img src="../../../../assets/img/about us admin.png" class="image" alt=""/>
            </div>
            <div>
                <div class="refund_title WrapData">{{ reportDetail.name }}</div>
                <ul class="event_list flex-row">
                    <li class="calender"><img src="../../../../assets/icons/calender.svg" class="image" alt=""/>
                        <span [innerHTML]="reportDetail.startDateTime | ordinalDate : reportDetail.endDateTime"></span>
                    </li>
                </ul>
                <ul class="event_list">
                    <li class="time"><img src="../../../../assets/icons/event_clock_icon.svg" class="image" alt="" /> {{
                        reportDetail.startDateTime | date :
                        dateFormat.shortTime }} TO {{ reportDetail.endDateTime | date :
                        dateFormat.shortTime }}</li>
                    <li class="location"><img src="../../../../assets/icons/event_location_icon.svg" class="image" alt="" />
                        {{ reportDetail.eventAddress }}</li>
                </ul>
                <div class="amount">{{ currencySymbolConstant.euroSign }} {{ reportDetail.amount }}</div>
            </div>
            <div>
                <div class="refund_profile">
                    <img [src]="reportDetail.customerImage"
                        onerror="this.src = '../../../../assets/img/default-user-profile.svg'" alt="" />
                    <ul>
                        <li>{{LabelConstant.reporter}}</li>
                        <li class="WrapData">{{ reportDetail.customerName }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="refund_customer_message mb-3">
            <div class="title">{{LabelConstant.customerMessage}}</div>
            <textarea class="form-control" rows="2" cols="50" disabled>{{ reportDetail.customerReason }}</textarea>
        </div>
        <div class="reply_to_reporter">
            <div class="title">{{LabelConstant.replyToReporter}}</div>
            <textarea class="form-control" rows="2" cols="50">{{ reportDetail.adminReason }}</textarea>
        </div>
    </div>
    <div *ngIf="reportDetail.status == reportStatus.PENDING">
        <div class="refund_box inprocess p-3 mb-3">
            <div class="imagebox">
                <img src="../../../../assets/img/test_image.png" class="image" alt="" />
            </div>
            <div>
                <div class="refund_title WrapData">{{ reportDetail.name }}</div>
                <ul class="event_list flex-row">
                    <li class="calender"><img src="../../../../assets/icons/calender.svg" class="image" alt=""/>
                        <span [innerHTML]="reportDetail.startDateTime | ordinalDate : reportDetail.endDateTime"></span>
                    </li>
                </ul>
                <ul class="event_list">
                    <li class="time"><img src="../../../../assets/icons/event_clock_icon.svg" class="image" alt=""/>{{
                        reportDetail.startDateTime | date :
                        dateFormat.shortTime }} TO {{ reportDetail.endDateTime | date :
                        dateFormat.shortTime }}</li>
                    <li class="location"><img src="../../../../assets/icons/event_location_icon.svg" class="image" alt=""/>
                        {{ reportDetail.eventAddress }}</li>
                </ul>
                <div class="amount">{{ currencySymbolConstant.euroSign }} {{ reportDetail.amount }}</div>
            </div>
            <div>
                <div class="refund_profile">
                    <img [src]="reportDetail.customerImage"
                        onerror="this.src = '../../../../assets/img/default-user-profile.svg'" alt=""/>
                    <ul>
                        <li>{{LabelConstant.reporter}}</li>
                        <li class="WrapData">{{ reportDetail.customerName }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="refund_customer_message mb-3">
            <div class="title">{{LabelConstant.customerMessage}}</div>
            <textarea class="form-control" rows="2" cols="50" disabled>{{ reportDetail.customerReason }}</textarea>
        </div>
        <div class="reply_to_reporter">
            <div class="title">{{LabelConstant.replyToReporter}}</div>
            <textarea class="form-control" rows="2" cols="50">{{ reportDetail.adminReason }}</textarea>
        </div>
    </div>
    <div *ngIf="reportDetail.status == reportStatus.APPROVED || reportDetail.status == reportStatus.APPROVEDWITHREFUND">
        <div class="refund_box approve p-3 mb-3">
            <div class="imagebox">
                <img [src]="reportStatus.eventImage" onerror="this.src = '../../../../assets/img/about us admin.png'" class="image" alt=""/>
            </div>
            <div class="d-flex flex-column">
                <div class="refund_title WrapData">{{ reportDetail.name }}</div>
                <ul class="event_list flex-row">
                    <li class="calender"><img src="../../../../assets/icons/calender.svg" class="image" alt=""/>
                        <span [innerHTML]="reportDetail.startDateTime | ordinalDate : reportDetail.endDateTime"></span>
                    </li>
                </ul>
                <ul class="event_list">
                    <li class="time"><img src="../../../../assets/icons/event_clock_icon.svg" class="image" alt=""/>{{
                        reportDetail.startDateTime | date :
                        dateFormat.shortTime }} TO {{ reportDetail.endDateTime | date :
                        dateFormat.shortTime }}</li>
                    <li class="location"><img src="../../../../assets/icons/event_location_icon.svg" class="image" alt="" />
                        {{ reportDetail.eventAddress }}</li>
                </ul>
                <div class="amount" *ngIf="reportDetail.isRefundRequested">{{ currencySymbolConstant.euroSign }} {{ reportDetail.amount }}</div>
            </div>
            <div>
                <div class="refund_profile">
                    <img [src]="reportDetail.customerImage"
                        onerror="this.src = '../../../../assets/img/default-user-profile.svg'" alt=""/>
                    <ul>
                        <li>{{LabelConstant.reporter}}</li>
                        <li class="WrapData">{{ reportDetail.customerName }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="transiction_detail" *ngIf="reportDetail.refundStripeTransactionId != '' && reportDetail.refundStripeTransactionId != null">
            <div class="title">{{LabelConstant.details}}</div>
            <ul>
                <li><span>{{LabelConstant.transactionId}}</span><span>{{ reportDetail.refundStripeTransactionId }}</span></li>
                <li><span>{{LabelConstant.refundedAmount}}</span><span>{{currencySymbolConstant.euroSign}} {{ reportDetail.amount }}</span></li>
            </ul>
        </div>
        <div class="refund_customer_message mb-3">
            <div class="title">{{LabelConstant.customerMessage}}</div>
            <textarea class="form-control" rows="2" cols="50" disabled>{{ reportDetail.customerReason }}</textarea>
        </div>
        <div class="reply_to_reporter">
            <div class="title">{{LabelConstant.replyToReporter}}</div>
            <textarea class="form-control" rows="2" cols="50">{{ reportDetail.adminReason }}</textarea>
        </div>
    </div>
</mat-dialog-content>